import { gql } from "@apollo/client";

const GET_ALL_MONITOR_EVENTS = gql`
  query getMonitorEvents(
    $sortDirection: SortDirection
    $createdFrom: Date
    $createdTo: Date
    $isHandled: Boolean
    $eventTypes: [String]
    $skip: Int
    $take: Int
    $sortBy: ClientMonitoringEventSortBy
  ) {
    clientmonitoringevents(
      sortDirection: $sortDirection
      createdFrom: $createdFrom
      createdTo: $createdTo
      isHandled: $isHandled
      eventTypes: $eventTypes
      skip: $skip
      take: $take
      sortBy: $sortBy
    ) {
      totalCount
      items {
        clientIdentifier
        clientName
        createdAt
        eventType
        handled
        id
        comments {
          items {
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
            id
          }
        }
        descriptionLines
        detectedAt
        __typename
        parameterExclusionOptions {
          canSetExpirationDate
          latestAllowedExpirationDate
        }
        parameters {
          id
          title
          __typename
          exclusions {
            __typename
            id
            activeUntil
            activeUntilFurtherNotice
            createdAt
            isActive
            comment {
              id
              content
              createdAt
              createdByUser {
                id
                firstName
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_ALL_MONITOR_EVENTS;
